export const BASE_URL = `${process.env.NEXT_PUBLIC_API_URL || ''}/api/1.0`
